import { render, staticRenderFns } from "./CuposRecord.vue?vue&type=template&id=90875fb4"
import script from "./CuposRecord.vue?vue&type=script&lang=js"
export * from "./CuposRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports